module.exports = __webpack_public_path__ + "img/monthly-sales-graph.f0e1e9be.svg";